import StudentOnlineHomework from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'studentId':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new StudentOnlineHomework(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineHomework/StudentOnlineHomework/create.js